import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-029d660f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { style: {"margin":"0 auto","text-align":"center"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Choose Your Setup", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { style: {"margin":"0 auto","width":"fit-content"} }
const _hoisted_8 = {
  key: 0,
  style: {"clear":"both"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: "tenant_btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.PerformLoginOnProd()))
        }, "Production"),
        _createElementVNode("div", {
          class: "tenant_btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.PerformLoginOnDev()))
        }, "Development")
      ]),
      (_ctx.working)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_Spinner)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}